import { Link } from 'react-router-dom';
import { Boxes } from 'lucide-react';

const SECTIONS: { title: string; links: { label: string; to: string }[] }[] = [
  {
    title: '서비스',
    links: [
      { label: '번들 둘러보기', to: '/bundles' },
      { label: '지역별 보기', to: '/regions' },
      { label: '선물하기', to: '/bundles?type=GIFT' },
    ],
  },
  {
    title: '회사',
    links: [
      { label: '소개', to: '/about' },
      { label: '이용약관', to: '/terms' },
      { label: '개인정보처리방침', to: '/privacy' },
    ],
  },
  {
    title: '고객지원',
    links: [
      { label: '도움말', to: '/help' },
      { label: '문의하기', to: '/contact' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t bg-muted/30">
      <div className="container py-12">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-gradient-to-br from-primary to-emerald-500 text-white">
                <Boxes className="h-4 w-4" />
              </span>
              <span className="text-lg font-extrabold tracking-tight">
                MOA<span className="text-primary">.</span>
              </span>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              함께 모으면 더 싸고 더 즐겁다.
              <br />
              지역 기반 대안적 소셜 이커머스.
            </p>
          </div>
          {SECTIONS.map((section) => (
            <div key={section.title}>
              <h3 className="mb-3 text-sm font-semibold">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-muted-foreground hover:text-foreground"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 border-t pt-6 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} Bundle Platform. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
